export const init = () => { // eslint-disable-line import/prefer-default-export
  setProductGroupAnchors();
  wrapProductList();
  wrapTitleVintage();
};

const setProductGroupAnchors = () => {
  const productGroupTitles = [...document.getElementsByClassName('v65-productGroup-title')];
  productGroupTitles.forEach((productGroupTitle) => {
    productGroupTitle.setAttribute('id', productGroupTitle.textContent.replace(/[^a-zA-Z0-9-_]/g, '-').toLowerCase());
  });
};

const wrapProductList = () => {
  const products = [...document.querySelectorAll('.v65-product2Up, .v65-product3Up, .v65-product5Up')];
  if (!products.length) {
    return false;
  }

  const productList = document.createElement('div');
  productList.className = 'product-list';
  products[0].parentElement.insertBefore(productList, products[0]);
  products.forEach(product => productList.appendChild(product));
  return productList;
};

const wrapTitleVintage = () => {
  const productTitles = [...document.getElementsByClassName('v65-product-title')];
  productTitles.forEach((productTitle) => {
    const link = productTitle.children[0];
    const productText = productTitle.textContent;
    const vintageRegex = /(\d{4}|N\/?V)/;
    const vintage = vintageRegex.exec(productText);

    if (vintage) {
      const title = productText.split(vintage[0]).filter(Boolean).join('').trim();
      link.innerHTML = `
        <span class="product-vintage">${vintage[0]}</span>
        <span class="product-title">${title}</span>
      `;
    }
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/products.js